import "./P2ButtonGroup.scss";
import { useEffect, useState } from "react";

export default function P2ButtonGroup(props) {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.onresize = () => {
      setInnerWidth(window.innerWidth);
    };

    return () => {
      window.onresize = null;
    };
  }, []);

  useEffect(() => {
    const buttonGroups = Array.from(
      document.querySelectorAll(".polymer-button-group-container")
    );
    for (const buttonGroup of buttonGroups) {
      const children = Array.from(buttonGroup.children);
      if (innerWidth > 768) {
        children.forEach((item) => (item.style.minWidth = "fit-content"));

        const maximumLength = Math.max(
          ...children.map((item) => item.offsetWidth)
        );

        children.forEach((item) => {
          item.style.minWidth = `${maximumLength}px`;
        });
      } else {
        children.forEach((item) => {
          item.style.minWidth = "100%";
        });
      }
    }
  }, [innerWidth, props.children]);

  return (
    <div className="polymer-button-group-container">
      {props.children}
    </div>
  );
}

P2ButtonGroup.propTypes = {};
